import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { resetPassword } from '../../../apiwrapper/user.ts';
import { useSelector } from "react-redux";

const ResetpasswordTwo = () => {
  const translation = useSelector(state => state.root.translation);
  const route = all_routes;
  const location = useLocation();
  const formData = location.state;
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return translation['err_pass_length'];
    }
    if (!hasUpperCase) {
      return translation['err_pass_up_letter'];
    }
    if (!hasLowerCase) {
      return translation['err_pass_down_letter'];
    }
    if (!hasNumber) {
      return translation['err_pass_one_num'];
    }
    if (!hasSpecialChar) {
      return translation['err_pass_one_special'];
    }
    return "";
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newPasswordError = validatePassword(newPassword);
    if (newPasswordError) {
      setError(newPasswordError);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError(translation['err_new_confirm_pass']);
      return;
    }

    try {
      
      const apiResponse = await resetPassword(formData.code,newPassword);

      if (apiResponse == '200') {
        navigate(route.signin);
      } else {
        setError(translation['failed_reset_pass']+apiResponse);
      }
    } catch (error) {
      setError(translation['api_error']);
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
          <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          <div className="login-content">
          <div className="login-userset">
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
              </div>
              <Link to={route.dashboard} className="login-logo logo-white">
                <ImageWithBasePath src="assets/img/logo-white.png" alt />
              </Link>
            <form onSubmit={handleSubmit}>
              <div className="login-userheading">
                <h3>{translation?.reset_password}</h3>
                <h4>
                {translation?.new_confirm_pass}
                </h4>
              </div>
              <div className="form-login">
                <label>{translation?.new_password}</label>
                <div className="pass-group">
                  <input type={showPassword ? "text" : "password"} className="pass-input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                  <span
                    className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                    onClick={togglePasswordVisibility}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
              <div className="form-login">
                <label>{translation?.confirm_new_password}</label>
                <div className="pass-group">
                  <input type={showPassword1 ? "text" : "password"} className="pass-input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                  <span
                    className={`fas toggle-password ${showPassword1 ? 'fa-eye' : 'fa-eye-slash'}`}
                    onClick={togglePasswordVisibility1}
                    style={{ cursor: 'pointer' }}
                  />
                  </div>
              </div>
              {error && <div className="error-message text-danger">{error}</div>}
              <div className="form-login">
                <button type="submit" className="btn btn-login">
                {translation?.change_password}
                </button>
              </div>
              <div className="signinform text-center">
                <h4>
                {translation?.return_to}{" "}
                  <Link to={route.signin} className="hover-a">
                  {translation?.sign_in}
                  </Link>
                </h4>
              </div>
              <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                <p>{translation?.copyright_message}</p>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetpasswordTwo;
